import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/auth/authSlice";
import service from "../../services/service";
import endpoints from "../../services/endpoints";
import { showToast } from "../../utils/toast";
import "./header.css";
import { Logo } from "../../assets/ExportImages";
import CommonModal from "../commonmodal/CommonModal";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [logoutLoading, setLogoutLoading] = useState(false);

  const handleLogout = async () => {
    if (logoutLoading) return;

    setLogoutLoading(true);
    try {
      await service.post(endpoints.auth.logout, {}, {});

      dispatch(logout());
      navigate("/", { replace: true });
      setShowLogoutModal(false);
    } catch (e) {
      showToast("Logout failed, please try again", "error");
    } finally {
      setLogoutLoading(false);
    }
  };

  const openLogoutModal = () => {
    setShowLogoutModal(true);
  };

  const closeLogoutModal = () => {
    setShowLogoutModal(false);
  };

  return (
    <>
      <header className="site-header">
        <div className="site-header__inner">
          {/* Logo */}
          <div className="site-header__logo" onClick={() => navigate("/")}>
            {/* apna logo image yahan laga */}
            <div className="site-header__logo-placeholder">
              <img src={Logo} height={32} width={80} />
            </div>
          </div>

          {/* Right side */}
          <div className="site-header__actions">
            {isLoggedIn ? (
              <button className="header-logout-btn" onClick={openLogoutModal}>
                Logout
              </button>
            ) : (
              <button
                className="header-login-btn"
                onClick={() => navigate("/login")}
              >
                Doctor Login
              </button>
            )}
          </div>
        </div>
      </header>
      <CommonModal
        isOpen={showLogoutModal}
        onClose={closeLogoutModal}
        title="Confirm Logout"
        message="Are you sure you want to logout?"
        onConfirm={handleLogout}
        onCancel={closeLogoutModal}
        confirmText="Yes, Logout"
        cancelText="Cancel"
        loading={logoutLoading}
      />
    </>
  );
};

export default Header;
